import React from 'react';
import { BookOpenIcon, EyeIcon, LayersIcon, PlayCircleIcon } from 'lucide-react';
const badges = [{
  icon: LayersIcon,
  top: '6 Complete',
  bottom: 'Volumes'
}, {
  icon: BookOpenIcon,
  top: '300+ Visual',
  bottom: 'Pages'
}, {
  icon: EyeIcon,
  top: '100% Visual',
  bottom: 'Coaching System'
}, {
  icon: PlayCircleIcon,
  top: 'Ready to Use',
  bottom: 'in Class'
}];
type ValueBadgesProps = {
  className?: string;
};
export function ValueBadges({
  className = ''
}: ValueBadgesProps) {
  return <ul className={`grid grid-cols-2 md:grid-cols-4 border border-gold/40 rounded-2xl overflow-hidden bg-carbon/60 ${className}`} data-id="element-377" data-mp="1nluqtiamo8ho">
      {badges.map(({
      icon: Icon,
      top,
      bottom
    }, index) => <li key={top} className={`flex items-center justify-center gap-3 px-3 py-4 text-left ${index % 2 === 1 ? 'border-l border-gold/25' : ''} ${index >= 2 ? 'border-t md:border-t-0 border-gold/25' : ''} ${index === 2 ? 'md:border-l md:border-gold/25' : ''}`} data-id="element-378" data-mp="1wf7vtilyv0k4" data-mpi={index}>
          <Icon size={22} className="text-gold shrink-0" aria-hidden="true" data-id="element-379" data-mp="1hlad6edb05gx" />
          <span className="leading-tight" data-id="element-380" data-mp="1ck4iib03284r">
            <span className="block text-white font-bold text-xs sm:text-sm uppercase tracking-wide" data-id="element-381" data-mp="1cn8sjp08by3c">
              {top}
            </span>
            <span className="block text-smoke text-[11px] sm:text-xs uppercase tracking-wider" data-id="element-382" data-mp="13kzn3djtiuwt">
              {bottom}
            </span>
          </span>
        </li>)}
    </ul>;
}